"use client";

import { useState } from "react";

/**
 * Floating bottom-right control — follows the viewport while scrolling.
 * Uses plain CSS (.report-bug-float) so position is reliable.
 */
export function ReportBugButton() {
  const [open, setOpen] = useState(false);
  const [note, setNote] = useState("");
  const [sent, setSent] = useState(false);

  function submit(e: React.FormEvent) {
    e.preventDefault();
    console.info("[virtuous] bug report", {
      note: note.trim(),
      path: typeof window !== "undefined" ? window.location.pathname : "",
      at: new Date().toISOString(),
    });
    setSent(true);
    setNote("");
    setTimeout(() => {
      setSent(false);
      setOpen(false);
    }, 1600);
  }

  return (
    <div className="report-bug-float" role="complementary" aria-label="Report a bug">
      {open && (
        <div className="card w-full p-4 shadow-lg">
          <p className="text-sm font-semibold text-title">Report a bug</p>
          <p className="mt-1 text-[11px] text-body">
            What went wrong? Include what you clicked if you can.
          </p>
          {sent ? (
            <p className="mt-3 text-sm font-medium text-teal-800">
              Thanks — noted.
            </p>
          ) : (
            <form onSubmit={submit} className="mt-3 space-y-2">
              <textarea
                className="input-field text-sm"
                rows={3}
                required
                value={note}
                onChange={(e) => setNote(e.target.value)}
                placeholder="Describe the bug…"
              />
              <div className="flex flex-wrap gap-2">
                <button type="submit" className="btn-primary text-sm">
                  Send
                </button>
                <button
                  type="button"
                  className="btn-ghost text-sm"
                  onClick={() => setOpen(false)}
                >
                  Cancel
                </button>
              </div>
            </form>
          )}
        </div>
      )}
      <button
        type="button"
        onClick={() => {
          setOpen((v) => !v);
          setSent(false);
        }}
        className="btn-ghost text-sm"
        aria-expanded={open}
        aria-label="Report a bug"
      >
        Report a bug
      </button>
    </div>
  );
}
